/*
 Calculation Data Sheet
*/

import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InputTextMat from "../../../../components/common/InputText/InputTextMatWithClose";
import IconImage from ".//..//..//..//..//assets//images//icons//image.png";
import ButtonOutlineFluid from "../../../../components/common/buttons/ButtonOutlineFluid";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import SquareRound from ".//..//..//..//..//assets//images//icons//square-rounded.svg";
import ConditionLabel from "../../../../components/calculator/ConditionLabel/ConditionLabel";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { toast } from "react-toastify";
import { ROUTES } from "../../../../constants/Routes";

const KalkulacioAdatlapja = () => {
  const { state } = useLocation();
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const proposalId = searchParams.get("p-id");
  const apiBasePath = process.env.REACT_APP_API_PATH;

  const { clearAuth, getAuth } = useAuth();
  useEffect(() => {
    console.log(state);
  }, []);

  const [nev, setNev] = useState("");
  const [ugyfel, setUgyfel] = useState("");
  const [telefonszam, setTelefonszam] = useState("");
  const [email, setEmail] = useState("");
  const [proposalDate, setPrposalDate] = useState("");
  const [proposalStatus, setProposalStatus] = useState(0);

  const [tourPlan, setTourPlan] = useState([]);
  const [streetViewImages, setStreetViewImages] = useState([]);

  const [jarmu_szukseglet, setJarmuSzukseglet] = useState(0);
  const [munkaero_szukseglet, setMunkaeroSzukseglet] = useState(0);
  const [tavolsag, setTavolsag] = useState(0);
  const [terfogat, setTerfogat] = useState(0);
  const [alacsony_ar, setAlacsonyAr] = useState(0);
  const [utvonal_ar, setUtvonalAr] = useState(0);
  const [stop_ar, setStopAr] = useState(0);
  const [nincs_zone_ar, setNincsZoneAr] = useState(0);
  const [bonstasi_ar, setBonstasiAr] = useState(0);
  const [telepitesi_ar, setTelepitesiAr] = useState(0);
  const [csomagolasi_ar, setCsomagolsiAr] = useState(0);
  const [buborekfolio_ar, setBuborekfolioAr] = useState(0);
  const [nehez_rakomany_ar, setNehezRakomanyAr] = useState(0);
  const [butoremelo_ar, setButoremeloAr] = useState(0);
  const [kulso_lift_ar, setKulsoLiftAr] = useState(0);
  const [bolti_ar, setBoltiAr] = useState(0);
  const [szemelyzeti_ar, setSzemelyzetiAr] = useState(0);
  const [konyhaszerelo_ar, setKonyhaszereloAr] = useState(0);
  const [villanyszerelo_ar, setVillanyszereloAr] = useState(0);
  const [teljes_ar, setTeljesAr] = useState(0);
  const [kedvezmeny, setKedvezmeny] = useState(0);
  const [kuchenmonteur_ar, setKuchenmonteurAr] = useState(0);
  const [osszesen, setOsszesen] = useState(0);
  const [megjegyes, setMegjegyes] = useState("");
  const [proposalKey, setProposalKey] = useState("");

  const [tetelAr, setTetalAr] = useState(0);
  const [verpackungsmaterial_ar, setVerpackungsmaterialAr] = useState(0);

  const fetchSummaryData = () => {
    setSpinnerVisible(true);
    HttpHelper.GetRequest({
      route: `${API_ROUTES.PR_TOURPLAN_GET_SUMMERY}?proposal_id=${proposalId}`,
      token: getAuth()?.bearerToken,
    })
      .then((data) => {
        if (data.status == 200) {
          console.log(data?.data?.summeryData);
          const summeryData = data?.data?.summeryData;
          const proposalData = data?.data?.proposalData;
          const proposalTourPlan = data?.data?.proposalTourPlan;
          const stImage = data?.data?.stImage;
          setProposalKey(proposalData[0]?.proposal_number);
          console.log(proposalData);
          setTourPlan(proposalTourPlan);

          setStreetViewImages(stImage);
          // set proposal data
          setNev(`${proposalData[0]?.keresztnev} ${proposalData[0]?.vezeteknev}`);
          setUgyfel(proposalData[0]?.ugyfelszam);
          setTelefonszam(proposalData[0]?.telefonszam);
          setEmail(proposalData[0]?.email);
          setProposalStatus(proposalData[0]?.status);
          const date = new Date(proposalData[0]?.created_at).toISOString().split("T")[0];
          console.log(date);
          setPrposalDate(date);

          // set Summery Data
          setJarmuSzukseglet(summeryData[0]?.jarmu_szukseglet);
          setMunkaeroSzukseglet(summeryData[0]?.munkaero_szukseglet);
          setTavolsag(summeryData[0]?.tavolsag);
          setTerfogat(summeryData[0]?.terfogat);
          setAlacsonyAr(summeryData[0]?.alacsony_ar);
          setUtvonalAr(summeryData[0]?.utvonal_ar);
          setStopAr(summeryData[0]?.stop_ar);
          setNincsZoneAr(summeryData[0]?.nincs_zone_ar);
          setBonstasiAr(summeryData[0]?.bonstasi_ar);
          setTelepitesiAr(summeryData[0]?.telepitesi_ar);
          setCsomagolsiAr(summeryData[0]?.csomagolasi_ar);
          setBuborekfolioAr(summeryData[0]?.buborekfolio_ar);
          setNehezRakomanyAr(summeryData[0]?.nehez_rakomany_ar);
          setButoremeloAr(summeryData[0]?.butoremelo_ar);
          setKulsoLiftAr(summeryData[0]?.kulso_lift_ar);
          setKuchenmonteurAr(summeryData[0]?.kuchenmonteur);
          setBoltiAr(summeryData[0]?.bolti_ar);
          setSzemelyzetiAr(summeryData[0]?.szemelyzeti_ar);
          setKonyhaszereloAr(summeryData[0]?.konyhaszerelo_ar);
          setVillanyszereloAr(summeryData[0]?.villanyszerelo_ar);
          setTeljesAr(summeryData[0]?.teljes_ar);
          setKedvezmeny(summeryData[0]?.kedvezmeny);
          setOsszesen(summeryData[0]?.osszesen);
          setTetalAr(summeryData[0]?.tetal_ar);
          setVerpackungsmaterialAr(summeryData[0]?.verpackungsmaterial_ar);

          setSpinnerVisible(false);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else {
          toast.error("Unknown server error 1!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Unknown server error 2!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSpinnerVisible(false);
      });
  };
  useEffect(() => {
    fetchSummaryData();
  }, []);

  console.log(tourPlan);

  const downloadBase64Image = (base64String, fileName) => {
    var a = document.createElement("a"); //Create <a>
    a.href = base64String; //Image Base64 Goes here
    a.download = `${fileName}.png`; //File name Here
    a.click(); //Downloaded file
  };

  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3.7rem] flex flex-col sm:items-center justify-between sm:flex-row gap-10">
        <div className="flex flex-row items-center gap-[1.5rem]">
          <img src={SquareRound} className="w-[5rem] md:w-[6.25rem]" />
          <div className="flex flex-col">
            <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[2rem] font-bold leading-[2.5rem]">
              {proposalKey}
            </span>
            <span className="text-text-seondary-color text-[0.9rem] md:text-[1rem] font-bold leading-normal">
              {nev}
            </span>
          </div>
        </div>
        <div className="flex flex-col  sm:text-end gap-[1.25rem]">
          <div>
            {proposalStatus == 1 ? (
              <ConditionLabel condition={"BEFEJEZETT"} />
            ) : (
              <ConditionLabel condition={"FOLYAMATBAN"} />
            )}
          </div>
          <span className="text-[0.9rem] md:text-[1.25rem]">
            Létrehozás dátuma <span className="font-bold">{proposalDate}.</span>
          </span>
        </div>
      </div>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem] flex flex-col lg:flex-row gap-10">
        <div className="flex flex-col gap-[3.125rem] w-full lg:w-1/2">
          {/*  */}
          <div className="flex flex-col gap-[1.6rem]">
            <h2 className="text-[1rem] font-bold text-text-primary-color leading-normal font-lato">Kontakt adatok</h2>
            <InputTextMat label={`Név`} value={nev} readOnly={true} />
            <InputTextMat label={`Ügyfél szám`} value={ugyfel} readOnly={true} />
            <InputTextMat label={`Telefonszám`} value={telefonszam} readOnly={true} />
            <InputTextMat label={`Email cím`} value={email} readOnly={true} />
          </div>
          {/*  */}
          <div className="flex flex-col gap-[1.6rem]">
            <h2 className="text-[1rem] font-bold text-text-primary-color leading-normal font-lato">
              Megbízás részletei
            </h2>

            {tourPlan.slice(0, -1).map((tPlan, index) => {
              return (
                <>
                  <InputTextMat label={`Felpakolás helye`} value={tPlan?.cim} readOnly={true} />
                  <InputTextMat label={`Lerakodás helye`} value={tourPlan[index + 1]?.cim} readOnly={true} />
                </>
              );
            })}

            {/* <InputTextMat label={`Lerakodás helye`} />
            <InputTextMat label={`Felpakolás helye`} />
            <InputTextMat label={`Lerakodás helye`} /> */}
          </div>
          {/*  */}
          <div className="flex flex-col gap-[2.5rem]">
            <div className="flex justify-between">
              <h2 className="text-[1rem] font-bold text-text-primary-color leading-normal font-lato">Csatolmányok</h2>
              <h2 className="text-[1rem] underline font-bold text-text-primary-color leading-normal font-lato">
                Összes letöltése
              </h2>
            </div>
            <ul className="flex flex-col gap-[1.875rem]">
              {streetViewImages.map((image, index) => (
                <li className="flex justify-between">
                  <div className="flex items-center gap-8">
                    <img src={IconImage} className="w-8 h-8" />
                    <span>Printscreen_0{index + 1}</span>
                  </div>
                  <span
                    className="underline cursor-pointer"
                    onClick={() =>
                      downloadBase64Image(`data:image/png;base64, ${image?.image}`, `Printscreen_0${index + 1}`)
                    }
                  >
                    Letöltés
                  </span>
                </li>
              ))}

              {/* <li className="flex justify-between">
                <div className="flex items-center gap-8">
                  <img src={IconPdf} className="w-8 h-8" />
                  <span>Printscreen_01</span>
                </div>
                <span className="underline">Letöltés</span>
              </li>
              <li className="flex justify-between">
                <div className="flex items-center gap-8">
                  <img src={IconPdf} className="w-8 h-8" />
                  <span>Printscreen_01</span>
                </div>
                <span className="underline">Letöltés</span>
              </li> */}
            </ul>
          </div>
        </div>

        <div className="w-full lg:w-1/2">
          <h2 className="text-[1.5rem] font-bold px-[1.625rem] text-text-primary-color leading-normal font-lato">
            Létszám szükséglet
          </h2>
          <ul className="flex flex-col gap-[1.25rem] mt-[1.25rem] px-[1.625rem] mb-[3.75rem] text-[1rem] font-lato font-bold">
            <li className="flex justify-between gap-2">
              <span className="w-full ">Jármű szükséglet</span>
              <span className="w-20 text-start ms-1">{jarmu_szukseglet}</span>
              <span className="w-20 break-all text-end ms-1">DB</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Munkaerő szükséglet</span>
              <span className="w-20 text-start ms-1">{munkaero_szukseglet}</span>
              <span className="w-20 break-all text-end ms-1">DB</span>
            </li>
          </ul>
          <h2 className="text-[1.5rem] px-[1.625rem] font-bold text-text-primary-color leading-normal font-lato">
            Felmerülő költségek
          </h2>
          <ul className="flex flex-col gap-[1.25rem] mt-[1.25rem] px-[1.625rem] text-[1rem] font-lato font-bold">
            <li className="flex justify-between gap-2">
              <span className="w-full ">Távolság</span>
              <span className="w-20 text-start ms-1">{tavolsag}</span>
              <span className="w-20 break-all text-end ms-1">KM</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Térfogat</span>
              <span className="w-20 text-start ms-1">{terfogat}</span>
              <span className="w-20 break-all text-end ms-1">
                {" "}
                m<sup>3</sup>
              </span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Emelet ár</span>
              <span className="w-20 text-start ms-1">{alacsony_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Útvonal ár</span>
              <span className="w-20 text-start ms-1">{utvonal_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Stop ár</span>
              <span className="w-20 text-start ms-1">{stop_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Nincs megállási zóna (jóváhagyott, kialakított) ár</span>
              <span className="w-20 text-start ms-1">{nincs_zone_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Bontási ár</span>
              <span className="w-20 text-start ms-1">{bonstasi_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Telepítési ár</span>
              <span className="w-20 text-start ms-1">{telepitesi_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full "> Csomagolási ár</span>
              <span className="w-20 text-start ms-1">{csomagolasi_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full "> Buborékfólia ár</span>
              <span className="w-20 text-start ms-1">{buborekfolio_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Nehéz rakomány felár</span>
              <span className="w-20 text-start ms-1">{nehez_rakomany_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Bútoremelő ár</span>
              <span className="w-20 text-start ms-1">{butoremelo_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Külső lift ára, kezelővel</span>
              <span className="w-20 text-start ms-1">{kulso_lift_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Fel- és lepakolás ára</span>
              <span className="w-20 text-start ms-1">{bolti_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Személyzeti ár</span>
              <span className="w-20 text-start ms-1">{szemelyzeti_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Küchenmonteur ár</span>
              <span className="w-20 text-start ms-1">{kuchenmonteur_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Konyhaszerelő ár</span>
              <span className="w-20 text-start ms-1">{konyhaszerelo_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Villanyszerelő ár</span>
              <span className="w-20 text-start ms-1">{villanyszerelo_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Tétel ár</span>
              <span className="w-20 text-start ms-1">{tetelAr}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
            <li className="flex justify-between gap-2">
              <span className="w-full ">Verpackungsmaterial ár</span>
              <span className="w-20 text-start ms-1">{verpackungsmaterial_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </li>
          </ul>
          <hr className="my-[1.875rem]" />
          <div className="flex flex-col gap-[1.25rem] mt-[1.25rem] px-[1.625rem] text-[1rem] sm:text-[1.25rem] font-lato font-bold">
            <div className="flex justify-between gap-2">
              <span className="w-full ">Teljes ár</span>
              <span className="w-20 text-start ms-1">{teljes_ar}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </div>
            <div className="flex justify-between gap-2">
              <span className="w-full ">Kedvezmény</span>
              <span className="w-20 text-start ms-1">{kedvezmeny}</span>
              <span className="w-20 break-all text-end ms-1">%</span>
            </div>
          </div>
          <div className="flex flex-col gap-[1.25rem] mt-[1.25rem]  text-[1rem] sm:text-[1.25rem]  font-lato font-bold">
            <div className="flex justify-between gap-2 bg-[#0655671a] text-secondary-color px-[1.625rem] py-[0.625rem]">
              <span className="w-full ">Összesen</span>
              <span className="w-20 text-start ms-1">{osszesen}</span>
              <span className="w-20 break-all text-end ms-1">EUR</span>
            </div>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-2 mt-[3.75rem]  gap-[1.625rem] text-[1rem] sm:text-[1.25rem] font-lato font-bold">
            <div className="w-full">
              <a target="_black" href={`${apiBasePath}/invoice?invoiceid=${proposalId}`}>
                <ButtonOutlineFluid label={`Számla generálása`} />
              </a>
            </div>
            <div className="w-full">
              <Link to={`${ROUTES.CAL_MANAGE_CUSTOMER_DATA}?p-id=${proposalId}`}>
                <ButtonFluid label={`Kalkuláció szerkesztése`} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KalkulacioAdatlapja;
